import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const ATTENTION_COUNTS_KEY = ["dashboard", "attention-counts"] as const;

/**
 * GET /v1/orders/attention-counts — unfiltered, for the dashboard's "Needs
 * attention" KPI card. The orders feature has its own filtered variant
 * (`features/orders/api/use-attention-counts.ts`); features may not import
 * each other, so the dashboard owns this thin unfiltered call.
 */
export function useAttentionCounts() {
  return useQuery({
    queryKey: ATTENTION_COUNTS_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/orders/attention-counts");
      if (error) throw error;
      return data;
    },
    refetchInterval: 60_000,
  });
}
